import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { decodeFile } from 'reusable/utils/file-operations'
import * as Sentry from '@sentry/browser'

interface FileNameProps {
   /** The given child must be a single string. YOU ARE NOT MEANT TO PUT MORE IN THAN JUST THE FILENAME */
   children?: string
}

/**
 * Given a file name, we take out the ulid part so it looks formatted. This way wont dont need a bunch of extra logic in each component handling files
 */
export default observer(function FileName(props: FileNameProps) {
   const fileName = useMemo(() => {
      if (!props.children) return ''
      try {
         const { file } = decodeFile(props.children)
         return file.name
      } catch (error: any) {
         Sentry.captureException(error, { tags: { component: 'FileName', action: 'decodeFile', input: props.children } })
         // If for whatever reason this fails, just show the full filename. It's better than nothing
         return props.children
      }
   }, [props.children])

   return fileName
})
